// Import necessary React and React Router hooks
import { useState, useReducer } from "react";
import { useNavigate } from "react-router-dom";
// Import necessary axios library
import axios from "axios";
// Import necessary Material-UI components
import { Grid } from "@mui/material";
// Import custom components
import { SampleRequestDetailsForm, ViewRequestDetails } from "./";
// Import custom hooks and context
import { NewRequestContext } from "../context";
import { newRequestReducer } from "../functions";
import { apiURI, authErrorRedirect, useAuthInfo } from "../../common";

/**
 * AddRequest component for creating a new sample request
 * @param {Object} props - Component props including data, and callbacks.
 */
export function AddRequest() {
  // Initialize state using the newRequestReducer and initial state
  const [state, dispatch] = useReducer(newRequestReducer, {
    itemList: "",
    sampleRequestDetails: "",
    sampleRequestFormDisplay: "flex",
  });
  // Access the decoded authentication information
  const decoded = useAuthInfo();
  // State to store any errors
  const [errors, setErrors] = useState();
  // Hook to navigate programmatically
  const history = useNavigate();
  // State to track if the form is currently being submitted
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    // Make a POST request to the server with the sample request details to save a new form
    axios
      .post(`${apiURI}/form/new-request`, {
        ...state.sampleRequestDetails,
        user: { role: decoded.role, email: decoded.email },
      })
      .then(() => history("/success")) // Redirect to success page on successful submission
      .catch((response) => {
        console.log("error in axios form call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history); // Handle authentication errors
      });
    // eslint-disable-next-line no-console
  };
  // Log any errors to the console for debugging purposes
  errors && console.log({ errors });

  return (
    <NewRequestContext.Provider value={{ state, dispatch }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          marginLeft: "auto",
          marginRight: "auto",
          paddingBottom: 4,
          maxWidth: "100vw",
        }}
      >
        {/* Render the SampleRequestDetailsForm component within a Card */}

        <SampleRequestDetailsForm decoded={decoded} />

        {/* Conditionally render the ViewRequestDetails component if sampleRequestDetails exists in the state */}
        {state.sampleRequestDetails && (
          <ViewRequestDetails
            isSubmitting={isSubmitting}
            handleSubmit={handleSubmit}
          />
        )}
      </Grid>
    </NewRequestContext.Provider>
  );
}
